<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
  useHead({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          '@id': 'https://momentshare.io/#organization',
          'name': 'Momentshare',
          'legalName': 'Momentshare B.V.',
          'url': 'https://momentshare.io',
          'logo': {
            '@type': 'ImageObject',
            'url': 'https://momentshare.io/android-chrome-256x256.png',
            'width': 256,
            'height': 256,
          },
          'address': {
            '@type': 'PostalAddress',
            'streetAddress': 'Broedertrouw 16',
            'postalCode': '9079 KX',
            'addressLocality': 'Sint Jacobiparochie',
            'addressCountry': 'NL',
          },
          'vatID': 'NL868147941B01',
          'identifier': {
            '@type': 'PropertyValue',
            'propertyID': 'KvK',
            'value': '97634271',
          },
          'contactPoint': {
            '@type': 'ContactPoint',
            'contactType': 'customer support',
            'email': 'info@momentshare.io',
            'telephone': '+31617387177',
            'availableLanguage': ['English', 'Dutch', 'Spanish', 'French', 'German'],
          },
          'sameAs': [
            'https://www.trustpilot.com/review/momentshare.io',
            'https://www.linkedin.com/company/momentshare-io',
            'https://www.instagram.com/momentshare_io',
            'https://www.facebook.com/p/Momentshareio-61550916671583',
          ],
        }),
      },
    ],
  })
</script>
